<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router';
import { Home, FileText, ScanLine, Inbox, User } from 'lucide-vue-next';
import { computed } from 'vue';

const router = useRouter();
const route = useRoute();

const navItems = computed(() => {
  return [
    { name: 'Beranda', path: '/', icon: Home },
    { name: 'Pengajuan', path: '/requests', icon: FileText },
    { name: 'Absen', path: '/attendance', icon: ScanLine, isFab: true },
    { name: 'Inbox', path: '/inbox', icon: Inbox },
    { name: 'Profil', path: '/profile', icon: User },
  ];
});

const navigate = (path: string) => {
  router.push(path);
};

const isActive = (path: string) => {
  return route.path === path;
};
</script>

<template>
  <div class="fixed bottom-0 left-0 right-0 z-50">
    <!-- SVG Curve/Notch Background (Optional advanced effect, sticking to clean bar for now) -->
    <div class="bg-white dark:bg-slate-900 border-t border-gray-200 dark:border-slate-800 shadow-[0_-5px_15px_rgba(0,0,0,0.05)] dark:shadow-none pb-safe">
      <div class="relative flex justify-between items-center px-2 h-[4.5rem]">
        
        <template v-for="item in navItems" :key="item.name">
            <!-- Normal Nav Item -->
            <button
              v-if="!item.isFab"
              @click="navigate(item.path)"
              class="flex flex-1 flex-col items-center justify-center gap-1 active:scale-95 transition-all duration-200 group"
            >
              <div 
                class="relative p-1.5 rounded-xl transition-all duration-300"
                :class="isActive(item.path) ? 'bg-primary/10 dark:bg-primary/20 text-primary' : 'text-gray-400 dark:text-slate-500 hover:text-gray-600 dark:hover:text-slate-300'"
              >
                <component 
                  :is="item.icon" 
                  class="w-6 h-6 transition-transform duration-300"
                  :class="isActive(item.path) ? 'scale-110' : ''"
                  stroke-width="2"
                />
                 <span v-if="item.name === 'Inbox'" class="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full border-2 border-white dark:border-slate-900 hidden"></span>
              </div>
              <span 
                class="text-[10px] font-bold tracking-wide transition-colors duration-200"
                :class="isActive(item.path) ? 'text-primary' : 'text-gray-400 dark:text-slate-500'"
              >
                {{ item.name }}
              </span>
            </button>

            <!-- Center FAB -->
            <div v-else class="relative flex-1 flex justify-center items-end pointer-events-none">
                 <button
                  @click="navigate(item.path)"
                  class="pointer-events-auto absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gradient-to-br from-primary to-[#1f4653] shadow-lg shadow-primary/40 text-white rounded-full w-16 h-16 p-0 border-[6px] border-gray-50 dark:border-slate-900 flex items-center justify-center transition-transform active:scale-95 group"
                 >
                    <ScanLine class="w-8 h-8 group-hover:rotate-12 transition-transform duration-300" stroke-width="2" />
                 </button>
                 <span class="text-[10px] font-bold text-gray-400 dark:text-slate-500 mb-2 mt-auto">{{ item.name }}</span>
            </div>
        </template>

      </div>
    </div>
  </div>
</template>

<style scoped>
.pb-safe {
  padding-bottom: env(safe-area-inset-bottom, 20px);
}
</style>
